import React from "react";
import { withLocalize } from "react-localize-redux";
import SEO from "./components/SEO";

const GuestLayout = ({
  title,
  meta,
  children,
  translate,
  activeLanguage,
  defaultLanguage,
}) => {
  return (
    <>
      <SEO
        title={title}
        meta={meta}
        translate={translate}
        activeLanguage={activeLanguage}
        defaultLanguage={defaultLanguage}
      />
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, { translate, activeLanguage });
        }
        return child;
      })}
    </>
  );
};

export default withLocalize(GuestLayout);
